import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconOptions = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M7.5 9.25C8.39746 9.25 9.125 8.52246 9.125 7.625C9.125 6.72754 8.39746 6 7.5 6C6.60254 6 5.875 6.72754 5.875 7.625C5.875 8.52246 6.60254 9.25 7.5 9.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.625 9.25C3.52246 9.25 4.25 8.52246 4.25 7.625C4.25 6.72754 3.52246 6 2.625 6C1.72754 6 1 6.72754 1 7.625C1 8.52246 1.72754 9.25 2.625 9.25Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12.375 9.25C13.2725 9.25 14 8.52246 14 7.625C14 6.72754 13.2725 6 12.375 6C11.4775 6 10.75 6.72754 10.75 7.625C10.75 8.52246 11.4775 9.25 12.375 9.25Z",
			fill: "currentColor"
		})
	]
});
export default SvgIconOptions;
